import { render } from "./InputCheckbox.vue?vue&type=template&id=5f77b44a&scoped=true"
import script from "./InputCheckbox.vue?vue&type=script&lang=js"
export * from "./InputCheckbox.vue?vue&type=script&lang=js"

import "./InputCheckbox.vue?vue&type=style&index=0&id=5f77b44a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f77b44a"

export default script